<template>
    <div class="charts_el" ref="chartsEl" v-show="visible"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
    name: "GjkcH5ExaminationDifficultPie",
    data() {
        return {
            chart: null,
            visible: false,
            resizeTimer: null
        };
    },
    mounted() {
        // 使用防抖的resize处理
        window.addEventListener('resize', this.debouncedResize);
    },
    methods: {
        // 初始化图表
        initCharts(echartsData) {
            this.visible = true;
            
            this.$nextTick(() => {
                // 先销毁旧实例
                if (this.chart) {
                    this.chart.dispose();
                    this.chart = null;
                }
                
                const chartDom = this.$refs.chartsEl;
                if (!chartDom) return;
                
                // 检查容器是否有实际尺寸
                if (chartDom.clientWidth === 0 || chartDom.clientHeight === 0) {
                    // 如果容器不可见，延迟重试
                    setTimeout(() => this.initCharts(), 100);
                    return;
                }
                
                try {
                    this.chart = echarts.init(chartDom);
                    this.setOption(echartsData);
                } catch (error) {
                    console.error('ECharts初始化失败:', error);
                }
            });
        },
        
        // 设置图表配置
        setOption(echartsData) {
            if (!this.chart) return;
            
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    right: '5%',
                    top: 'center',
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: {
                        color: '#606060',
                        fontSize: 12
                    }
                },
                series: [{
                    name: '难度分布',
                    type: 'pie',
                    radius: ['45%', '70%'],
                    center: ['35%', '50%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 8,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: false
                    },
                    emphasis: {
                        scale: false,
                        label: {
                            show: true,
                            fontSize: 14,
                            fontWeight: 'bold',
                            formatter: '{b}: {d}%'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: echartsData
                }],
                // 添加动画配置，减少重绘
                animation: true,
                animationDuration: 500,
                animationEasing: 'cubicOut'
            };
            
            this.chart.setOption(option);
        },
        
        // 防抖的resize处理
        debouncedResize() {
            if (this.resizeTimer) {
                clearTimeout(this.resizeTimer);
            }
            
            this.resizeTimer = setTimeout(() => {
                if (this.chart && this.visible) {
                    requestAnimationFrame(() => {
                        try {
                            this.chart.resize();
                        } catch (error) {
                            console.error('ECharts resize失败:', error);
                        }
                    });
                }
            }, 150);
        },
        
        // 手动调整大小
        resize() {
            if (this.chart && this.visible) {
                requestAnimationFrame(() => {
                    try {
                        this.chart.resize();
                    } catch (error) {
                        console.error('ECharts resize失败:', error);
                    }
                });
            }
        },
        
        // 销毁图表
        destroyChart() {
            if (this.chart) {
                try {
                    this.chart.dispose();
                } catch (error) {
                    console.error('ECharts销毁失败:', error);
                }
                this.chart = null;
            }
            this.visible = false;
            
            if (this.resizeTimer) {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = null;
            }
        }
    },
    beforeUnmount() {
        // 移除事件监听
        window.removeEventListener('resize', this.debouncedResize);
        
        // 销毁图表
        this.destroyChart();
    }
};
</script>

<style lang="scss" scoped>
.charts_el {
    width: 100%;
    height: 100%;
    position: relative;
    background: transparent;
}
</style>